import { render, staticRenderFns } from "./ApexMedicalChartNew.vue?vue&type=template&id=466a4c78&scoped=true"
import script from "./ApexMedicalChartNew.vue?vue&type=script&lang=js"
export * from "./ApexMedicalChartNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466a4c78",
  null
  
)

export default component.exports